var _rect, _path, _path2, _rect2, _g, _path3, _path4, _path5, _path6, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNzd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3396)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2754_3396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2754_3396)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2754_3396",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2754_3396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44061 12.4582L1.40632 14.123L13.0021 1.81011L14.5037 -0.663855L11.4594 -1.22029L6.72974 4.08571L2.92288 7.66071L-1.44061 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05084 13.6247L0.399539 14.5908L13.9645 -0.893656H11.928L-1.05084 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-1_2754_3396",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 0V-0.75H4.98887V0H5.73887ZM7.17637 0H7.92637V-0.75H7.17637V0ZM5.73887 5.75V6.5H6.48887V5.75H5.73887ZM0 5.75V5H-0.75V5.75H0ZM0 7.66667H-0.75V8.41667H0V7.66667ZM5.73887 7.66667H6.48887V6.91667H5.73887V7.66667ZM5.73887 13.4167H4.98887V14.1667H5.73887V13.4167ZM7.17637 13.4167V14.1667H7.92637V13.4167H7.17637ZM7.17637 7.66667V6.91667H6.42637V7.66667H7.17637ZM12.9375 7.66667V8.41667H13.6875V7.66667H12.9375ZM12.9375 5.75H13.6875V5H12.9375V5.75ZM7.17637 5.75H6.42637V6.5H7.17637V5.75ZM5.73887 0.75H7.17637V-0.75H5.73887V0.75ZM6.48887 5.75V0H4.98887V5.75H6.48887ZM0 6.5H5.73887V5H0V6.5ZM0.75 7.66667V5.75H-0.75V7.66667H0.75ZM5.73887 6.91667H0V8.41667H5.73887V6.91667ZM6.48887 13.4167V7.66667H4.98887V13.4167H6.48887ZM7.17637 12.6667H5.73887V14.1667H7.17637V12.6667ZM6.42637 7.66667V13.4167H7.92637V7.66667H6.42637ZM12.9375 6.91667H7.17637V8.41667H12.9375V6.91667ZM12.1875 5.75V7.66667H13.6875V5.75H12.1875ZM7.17637 6.5H12.9375V5H7.17637V6.5ZM6.42637 0V5.75H7.92637V0H6.42637Z",
    fill: "#F7FCFF",
    mask: "url(#path-10-outside-1_2754_3396)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8632 19.646L16.5958 20.5344L16.8379 18.6527L15.8125 17.3201L17.2295 17.0455L17.8632 15.3335L18.4969 17.0455L19.9139 17.3201L18.8886 18.6527L19.1306 20.5344L17.8632 19.646Z",
    fill: "#F50100",
    stroke: "#F7FCFF",
    strokeWidth: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2375 13.292L14.2602 13.9771L14.4469 12.5261L13.6563 11.4986L14.7489 11.2869L15.2375 9.9668L15.7261 11.2869L16.8188 11.4986L16.0281 12.5261L16.2148 13.9771L15.2375 13.292Z",
    fill: "#F50100",
    stroke: "#F7FCFF",
    strokeWidth: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.267 13.2884L19.2908 13.9726L19.4772 12.5233L18.6875 11.4969L19.7789 11.2854L20.267 9.9668L20.7551 11.2854L21.8465 11.4969L21.0567 12.5233L21.2432 13.9726L20.267 13.2884Z",
    fill: "#F50100",
    stroke: "#F7FCFF",
    strokeWidth: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1125 7.92535L17.1352 8.61039L17.3219 7.15945L16.5313 6.13189L17.6239 5.9202L18.1125 4.6001L18.6011 5.9202L19.6938 6.13189L18.9031 7.15945L19.0898 8.61039L18.1125 7.92535Z",
    fill: "#F50100",
    stroke: "#F7FCFF",
    strokeWidth: 0.35
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3396)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3396",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzd);
export default __webpack_public_path__ + "static/media/NZD.91193380836060ad5602073ea31c9bbd.svg";
export { ForwardRef as ReactComponent };